import { markSpeechEnd, markSpeechStart, markSpeechWord } from './voiceSignal';

/** Dutch text-to-speech via the browser. Returns false when unavailable. */
export function speakDutch(text: string, options: { volume?: number; onEnd?: () => void } = {}): boolean {
  if (typeof window === 'undefined' || !('speechSynthesis' in window)) return false;
  const synth = window.speechSynthesis;
  synth.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = 'nl-NL';
  utterance.rate = 1.02;
  utterance.pitch = 1;
  utterance.volume = options.volume ?? 1;
  const voices = synth.getVoices().filter((v) => v.lang?.toLowerCase().startsWith('nl'));
  const preferred = voices.find((v) => /natural|google|neural/i.test(v.name)) ?? voices[0];
  if (preferred) utterance.voice = preferred;
  utterance.onstart = () => markSpeechStart();
  utterance.onboundary = (e) => {
    if (e.name && e.name !== 'word') return;
    const length = e.charLength || (text.slice(e.charIndex).match(/^\S+/)?.[0].length ?? 5);
    markSpeechWord(length);
  };
  const finish = () => {
    markSpeechEnd();
    options.onEnd?.();
  };
  utterance.onend = finish;
  utterance.onerror = finish;
  synth.speak(utterance);
  return true;
}

export function cancelSpeech() {
  markSpeechEnd();
  if (typeof window !== 'undefined' && 'speechSynthesis' in window) window.speechSynthesis.cancel();
}
